import React from "react";
import useStyles from "../style";
import { TextField } from "@material-ui/core";

const InputComponent = ({ text, setPartnerCode, type, label, name, regularExpression, placeholder, isEnable, isRequired }) => {
    const classes = useStyles();
    const onChange = (e) => {
        setPartnerCode({ ...text, text: e.target.value });
    }
    const validateField = () => {
        if (regularExpression) {
            if (regularExpression.test(text.text) && text.text != '') {
                setPartnerCode({ ...text, valid: 'true' });
            } else {
                setPartnerCode({ ...text, valid: 'false' });
            }
        }
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>

            <TextField
                InputProps={{
                    classes: {
                        focused: classes.textBorder,
                        input: classes.input,
                    },
                }}
                disabled={isEnable ?? false}
                value={text.text}
                onChange={onChange}
                placeholder={placeholder}
                type={type}
                name={name}
                onKeyUp={validateField}
                onBlur={validateField}
                style={{ width: '85%' }}
                inputStyle={{ width: '85%' }}
            />
        </div>
    );
}

export default InputComponent;